<template>
  <div class="bzjd">
    <div class="card11">
      <div class="w1280">
        <div style="padding: 112px 0;">
          <div class="t11">数据标注基地</div>
          <div class="t22">
            人工智能数据服务专家 · 构建智能未来基础设施
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="title"></div>
    <div class="solgan"></div> -->
    <div class="w1280" >
      <div class="flexs">
        <div class="card1">
          <div class="flex-l">
            <div class="card-icon">🏭</div>
            <div>
              <div class="t1">泉州惠安数据标注基地</div>
              <div class="t2">东南沿海智能标注产业标杆 · 已运营</div>
            </div>
          </div>
          <div>
            作为福建省首批投入运营的AI数据标注基地，泉州惠安基地已形成<span
              style="color:#045588"
              >3D点云标注</span
            >与<span style="color:#045588">语音标注</span>双核心能力。
          </div>
          <div class="flexs" style="margin: 24px 32px;">
            <div class="mini-card">
              <div class="t3">30+</div>
              <div class="t4">专业团队</div>
            </div>
            <div class="mini-card">
              <div class="t3">500TB</div>
              <div class="t4">标注数据总量</div>
            </div>
          </div>
          <div>
            服务客户覆盖<span style="color:#045588">智慧医疗</span>、<span
              style="color:#045588"
              >智能驾驶</span
            >等领域，完成医疗影像标注、自动驾驶3D点云标注及方言语音转写等高复杂度项目。
          </div>
          <div class="flexs" style="margin: 24px 0;">
            <img style="width: 48%;height: 140px; border-radius: 12px;object-fit: cover;" src="../assets/img/tp1.png" />
            <img style="width: 48%;height: 140px; border-radius: 12px;object-fit: cover;" src="../assets/img/tp2.png" />
          </div>
          <div class="t5">技术亮点</div>
          <ul>
            <li>
              <span style="font-weight: bold;">3D点云标注：</span
              >采用多模态标注平台，支持激光雷达点云与摄像头图像同步标注，误差率低于0.5%。
            </li>
            <li>
              <span style="font-weight: bold;">语音标注：</span
              >覆盖闽南语、客家话等方言的语音转写与情感分析，助力区域化AI语音交互场景落地。
            </li>
          </ul>
          <div class="t5">配套保障</div>
          <div>
            基地通过<span style="color: #045588;">ISO 27001数据安全认证</span
            >，搭建区块链溯源系统，确保数据全流程可追溯。
          </div>
        </div>

        <div class="card2">
          <div class="flex-l">
            <div class="card-icon">🚀</div>
            <div>
              <div class="t1">闽清智能数据标注产业基地</div>
              <div class="t2">国家级"人工智能+"创新实验基地 · 规划建设中</div>
            </div>
          </div>
          <div>
            依托福建省数据管理局专项政策支持，闽清基地规划建设<span style="color: #045588;">2D/3D融合标注中心</span>与<span style="color: #045588;">语音语义联合实验室</span>。
          </div>
          <ul>
            <li>
              <span style="font-weight: bold;">技术创新：</span
              >部署4D-BEV标注系统，实现动态场景下的时空一致性标注；研发AI辅助标注工具，将人工标注效率提升300%。
            </li>
            <li>
              <span style="font-weight: bold;">行业赋能：</span
              >联合高校共建"地理信息标注数据集"，支撑灾害预警与城市规划AI应用；打造"语音标注开放平台"。
            </li>
            <li>
              <span style="font-weight: bold;">人才生态：</span
              >与本地职校合作开设"数据标注产教融合班"，年培养专业人才200人。
            </li>
          </ul>
          <div class="t5">配套保障</div>
          <div class="flexs" style="margin: 24px 32px;">
            <div class="mini-card" style="width: 100px;">
              <div class="t3">大模型</div>
              <div class="t4">训练数据</div>
            </div>
            <div class="mini-card" style="width: 100px;">
              <div class="t3">工业</div>
              <div class="t4">质检</div>
            </div>
            <div class="mini-card" style="width: 100px;">
              <div class="t3">智慧</div>
              <div class="t4">城市</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w1280">
      <div class="title" style="margin: 24px 0 48px;">整体优势</div>
      <div class="card3">
        <div class="card-1" v-for="(item, index) in list" :key="index">
          <div class="t1">{{ item.title }}</div>
          <div class="t2">{{ item.content }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list:[{title:'政策协同',content:'响应国家数据局《促进数据标注产业高质量发展实施意见》，构建"成熟基地+新兴枢纽"双轮驱动格局。'},{title:'技术互补',content:"惠安基地夯实垂直领域标注能力，闽清基地聚焦前沿技术研发，形成全链条服务生态。"},{title:'区域辐射',content:'依托福建数字经济发展优势，助力"数据要素×"行动计划在智能制造、智慧医疗等场景落地。'},]
    }
  },
}
</script>
<style lang="scss" scoped>
.bzjd {
  ul {
    margin: 24px 0;
    line-height: 1.6;
    padding-left: 24px;
    li {
      margin-bottom: 12px;
      &::marker {
        color: #10b981;
        font-size: 24px;
      }
    }
  }
  .card11 {
    background-image: linear-gradient(72deg, #7cd0ff54 7.43%, #f0efea 88.33%);
    width: 100%;
    height: 370px;
    margin-bottom: 48px;
  }
  .card3{
    padding: 48px;
    background: linear-gradient(135deg, rgba(79, 70, 229, 0.05) 0%, rgba(16, 185, 129, 0.05) 100%);
    border-radius: 16px;
    margin-bottom: 48px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .card-1{
      &:hover{
        transform: translateY(-5px);
        box-shadow: 0 12px 40px rgba(31, 38, 135, 0.15);
      }
      background: #fff;
      padding: 24px;
      border-radius: 12px;
      width: 300px;
      .t1{
        color: #1f2937;
        line-height: 1.6;
        font-size: 20px;
        font-weight: bold;
      }
    }
  }
  .title {
    margin-top: 48px;
    text-align: center;
    font-size: 40px;
    font-weight: bold;
    background: linear-gradient(90deg, #045588, #10b981);
    background-clip: text;
    margin-bottom: 12px;
  }
  .solgan {
    color: #6b7280;
    font-size: 16px;
    text-align: center;
    margin-bottom: 60px;
  }
  .w1280 {
    width: 1280px;
    margin: 0 auto;
    .t11 {
      color: #045588;
      font-size: 56px;
      font-weight: bold;
      line-height: 84px;
      text-align: center;
    }
    .t22 {
      margin: 32px 256px;
      text-align: center;
      font-size: 20px;
      color: #4b4f54bf;
    }
  }
  .flexs {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 30px;
    .card1,
    .card2 {
      &:hover{
        transform: translateY(-5px);
        box-shadow: 0 12px 40px rgba(31, 38, 135, 0.15);
      }
      margin-bottom: 40px;
      background: rgba(255, 255, 255, 0.2);
      backdrop-filter: blur(10px);
      border-radius: 16px;
      padding: 40px;
      width: 510px;
      height: 760px;
      box-shadow: 0 8px 32px rgba(31, 38, 135, 0.1);
      .t5 {
        color: #1f2937;
        line-height: 1.6;
        font-size: 20px;
        font-weight: bold;
        margin-top: 12px;
      }
      .mini-card {
        background: rgba(255, 255, 255, 1);
        width: 180px;
        padding: 12px 16px;
        border-radius: 8px;
        text-align: center;
        border: 1px solid rgba(31, 38, 135, 0.1);

        .t3 {
          font-size: 18px;
          font-weight: bold;
          color: #045588;
        }
        .t4 {
          font-size: 14px;
        }
      }
      .flex-l {
        display: flex;
        align-items: center;
        margin-bottom: 24px;
        .card-icon {
          width: 48px;
          height: 48px;
          background: linear-gradient(135deg, #045588, #045588);
          border-radius: 12px;
          font-size: 24px;
          text-align: center;
          line-height: 48px;
          margin-right: 12px;
        }
        .t1 {
          font-size: 24px;
          font-weight: 600;
          color: #1f2937;
        }
        .t2 {
          font-size: 14px;
          color: #6b7280;
        }
      }
    }
  }
}
</style>
